import { useState } from 'react';
import axios from "axios";
import { Formik } from 'formik';
import { Form as BootstrapForm, Alert, Row } from "react-bootstrap";
import * as Yup from 'yup';
import { AddressSearch, TextInput } from '../components/Form';
import ButtonSpinner from '../components/ButtonSpinner';

// Public claim submission form for a public animal.
const ClaimForm = ({ animalId, onSuccess }) => {

  const [submitError, setSubmitError] = useState('');

  const phoneRegex = /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,3}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/;
  const nameRegex = /^[a-z ,.'-]+$/i;
  const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

  const initial_coordinates = [0, 0];

  const initialData = {
    first_name: '',
    last_name: '',
    phone: '',
    alt_phone: '',
    email: '',
    address: '',
    apartment: '',
    city: '',
    state: '',
    zip_code: '',
    latitude: null,
    longitude: null,
    notes: '',
  };

  return (
    <Formik
      initialValues={initialData}
      validationSchema={Yup.object({
        first_name: Yup.string()
          .max(50, 'Must be 50 characters or less')
          .matches(nameRegex, "Name is not valid")
          .required('Required'),
        last_name: Yup.string()
          .max(50, 'Must be 50 characters or less')
          .matches(nameRegex, "Name is not valid")
          .required('Required'),
        phone: Yup.string()
          .matches(phoneRegex, "Phone number is not valid")
          .min(10, "Phone number is not valid")
          .required('Required'),
        alt_phone: Yup.string()
          .matches(phoneRegex, "Phone number is not valid"),
        email: Yup.string()
          .max(200, 'Must be 200 characters or less')
          .matches(emailRegex, "Email is not valid"),
        address: Yup.string().required('Required'),
        city: Yup.string().required('Required'),
        state: Yup.string().required('Required'),
        notes: Yup.string(),
      })}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitError('');
        axios.post('/reunification/api/publicclaim/', { ...values, animal: animalId })
          .then(() => {
            onSuccess();
          })
          .catch(() => {
            setSubmitError('Something went wrong submitting your claim. Please try again.');
            setSubmitting(false);
          });
      }}
    >
      {formikProps => (
        <BootstrapForm noValidate>
          {submitError ? <Alert variant="danger">{submitError}</Alert> : ""}
          <Row className="gx-2 gy-2">
            <TextInput xs="12" md="6" type="text" label="First Name*" name="first_name" />
            <TextInput xs="12" md="6" type="text" label="Last Name*" name="last_name" />
          </Row>
          <Row className="mt-3 gx-2 gy-2">
            <TextInput xs="12" md="6" type="text" label="Phone*" name="phone" />
            <TextInput xs="12" md="6" type="text" label="Alternate Phone" name="alt_phone" />
          </Row>
          <Row className="mt-3">
            <TextInput xs="12" type="text" label="Email" name="email" />
          </Row>
          <AddressSearch formikProps={formikProps} label={"Search For Your Address*"} show_apt={true} show_same={false} always_show={true} address_form={true} initial_coordinates={initial_coordinates} isOwner={true} is_intake={false} is_required={true} />
          <Row className="mt-3">
            <TextInput xs="12" as="textarea" label="Notes" name="notes" />
          </Row>
          <div className="mt-3 d-flex justify-content-end">
            <ButtonSpinner isSubmitting={formikProps.isSubmitting} isSubmittingText="Submitting..." type="button" onClick={() => { formikProps.submitForm() }}>
              <span>Submit Claim</span>
            </ButtonSpinner>
          </div>
        </BootstrapForm>
      )}
    </Formik>
  );
};

export default ClaimForm;
